import { useContext } from 'react';
import { SecurityContext } from '../contexts/security-context';
import { SecurityContextType } from '../types/SecurityContextType';

export const useSecurity = () => {
    return useContext<SecurityContextType>(SecurityContext);
};
